import React from "react";
import {
  Modal,
  FormTextarea,
  Button,
  Loader,
  FormCheckbox,
  FormSelect,
  FormInput,
} from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-flexbox-grid";
import { format } from "date-fns";

import axiosConfig from "../../utils/axiosConfig";

import AuthContext from "../../context/AuthContext";

export default class ModalSendEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      email: "DEFAULT",
      otherEmail: "",
      messageEmail: "",
      messageEmailRepairer: "",
      messageEmailConfirmation: "",
      messageEmailConfirmationRepairer: "",
      messageEmailInstant: "",
      messageEmailInstantRepairer: "",
      // "invitation" = le client prend RDV
      // "confirmation" = RDV déjà pris par l'expert
      // "instant" = visio instantanée (aucun RDV, aucun créneau)
      messageMode: "invitation",
    };
  }

  static contextType = AuthContext;

  // Un RDV est déjà pris sur le dossier -> on peut envoyer une confirmation.
  hasAppointment = () =>
    !!(this.props.dateAppointment && this.props.hourAppointment);

  // Les dossiers créés avant le correctif ont pu enregistrer un message portant
  // l'indentation du code source (template literal indenté). Ces e-mails sont du
  // texte brut : aucune indentation n'y est volontaire, on la retire.
  cleanMessage = (text) =>
    String(text || "")
      .split("\n")
      .map((line) => line.trim())
      .join("\n");

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  componentDidUpdate(prevProps) {
    const opened = prevProps.show !== this.props.show && this.props.show;
    const templatesChanged =
      prevProps.messageEmail !== this.props.messageEmail ||
      prevProps.messageEmailRepairer !== this.props.messageEmailRepairer ||
      prevProps.visioInstant !== this.props.visioInstant;
    if (opened || templatesChanged) {
      this.resetMessages();
    }
  }

  // Formate la date du RDV en JJ/MM/AAAA (tolère Date, ISO ou chaîne).
  formatAppointmentDate = () => {
    const value = this.props.dateAppointment;
    if (!value) return "";
    const date = new Date(value);
    return isNaN(date.getTime()) ? String(value) : format(date, "dd/MM/yyyy");
  };

  // Heure du RDV en HH:MM (retire les secondes éventuelles).
  formatAppointmentHour = () =>
    String(this.props.hourAppointment || "").slice(0, 5);

  getVehicleLabel = () =>
    `${this.props.brand || ""} ${this.props.model || ""} ${
      this.props.licensePlate || ""
    }`
      .replace(/\s+/g, " ")
      .trim();

  getSignature = () =>
    `Cordialement,
${this.context.name || ""}
${this.context.groupName ? this.context.groupName : ""}`;

  // Enveloppe l'e-mail : salutation + corps + signature.
  buildEmail = (isRepairer, body) =>
    `Bonjour ${
      isRepairer
        ? this.props.repairerName || ""
        : `${this.props.kind || ""} ${this.props.insuredName || ""}`.trim()
    },

${body}

${this.getSignature()}`;

  // Message de confirmation : le RDV est déjà réservé ([URL] remplacé côté serveur).
  buildConfirmationMessages = () => {
    const date = this.formatAppointmentDate();
    const hour = this.formatAppointmentHour();
    const vehicle = this.getVehicleLabel();

    const body = (isRepairer) =>
      `${
        isRepairer ? "L'expertise vidéo" : "Votre expertise vidéo"
      }${
        vehicle
          ? ` ${isRepairer ? "du véhicule" : "de votre véhicule"} ${vehicle}`
          : ""
      } en visioconférence est confirmée le ${date} à ${hour}. Le jour du rendez-vous, cliquez sur le lien ci-dessous pour rejoindre la visio : [URL]`;

    return {
      messageEmailConfirmation: this.buildEmail(false, body(false)),
      messageEmailConfirmationRepairer: this.buildEmail(true, body(true)),
    };
  };

  // Message de visio instantanée : aucun RDV, le client rejoint tout de suite.
  buildInstantMessages = () => {
    const vehicle = this.getVehicleLabel();

    const body = (isRepairer) =>
      `Nous réalisons l'expertise vidéo${
        vehicle
          ? ` ${isRepairer ? "du véhicule" : "de votre véhicule"} ${vehicle}`
          : ""
      } en visioconférence maintenant. Cliquez sur le lien ci-dessous pour rejoindre la visio immédiatement : [URL]`;

    return {
      messageEmailInstant: this.buildEmail(false, body(false)),
      messageEmailInstantRepairer: this.buildEmail(true, body(true)),
    };
  };

  resetMessages = () => {
    const { messageEmailConfirmation, messageEmailConfirmationRepairer } =
      this.buildConfirmationMessages();
    const { messageEmailInstant, messageEmailInstantRepairer } =
      this.buildInstantMessages();

    // Priorité : visio instantanée > RDV déjà pris > invitation
    let messageMode = "invitation";
    if (this.props.visioInstant) {
      messageMode = "instant";
    } else if (this.hasAppointment()) {
      messageMode = "confirmation";
    }

    this.setState({
      messageEmail: this.cleanMessage(this.props.messageEmail),
      messageEmailRepairer: this.cleanMessage(this.props.messageEmailRepairer),
      messageEmailConfirmation,
      messageEmailConfirmationRepairer,
      messageEmailInstant,
      messageEmailInstantRepairer,
      messageMode,
    });
  };

  // Nom du champ (et donc du message) actif selon destinataire + mode.
  getActiveMessageField = () => {
    const isRepairer = this.props.repairerEmail === this.state.email;
    if (this.state.messageMode === "instant") {
      return isRepairer ? "messageEmailInstantRepairer" : "messageEmailInstant";
    }
    if (this.state.messageMode === "confirmation") {
      return isRepairer
        ? "messageEmailConfirmationRepairer"
        : "messageEmailConfirmation";
    }
    return isRepairer ? "messageEmailRepairer" : "messageEmail";
  };

  // start sendEmail

  sendEmail = () => {
    const activeField = this.getActiveMessageField();

    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/send-email", {
        data: {
          id: this.props.id,
          token: this.props.token,
          email:
            this.state.email === "Autre"
              ? this.state.otherEmail
              : this.state.email,
          messageEmail: this.state[activeField],
          agencyEmail: this.props.agencyEmail,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.setState(
              {
                isLoad: false,
              },
              () => {
                this.props.getFolder(false);
                alert("Email envoyé");
                this.props.onClose();
              }
            );
          } else {
            this.sendEmailError();
          }
        })
        .catch(this.sendEmailError);
    });
  };

  sendEmailError = () => {
    this.setState({ isLoad: false }, () => alert("Une erreur est survenue."));
  };

  // end sendEmail

  render() {
    const activeField = this.getActiveMessageField();
    const activeMessage = this.state[activeField];

    return (
      <>
        <Modal
          show={this.props.show}
          onClose={this.props.onClose}
          title={`Envoyer un e-mail`}
        >
          <FormSelect
            className="mb-20"
            title="Destinataire"
            value={this.state.email}
            name="email"
            ignore={true}
            options={[
              { text: "Choix du destinataire", value: "DEFAULT" },
              {
                text: `Assuré : ${this.props.insuredEmail}`,
                value: this.props.insuredEmail,
              },
              {
                text: `Réparateur : ${this.props.repairerEmail}`,
                value: this.props.repairerEmail,
              },
              {
                text: `Autre`,
                value: "Autre",
              },
            ]}
            onChange={this.handleInputChange}
          />
          {this.state.email === "Autre" && (
            <FormInput
              className="mb-20"
              title="E-mail personnalisé"
              value={this.state.otherEmail}
              name="otherEmail"
              onChange={this.handleInputChange}
            />
          )}
          {this.props.visioInstant ? (
            <p
              className="mb-20"
              style={{ fontSize: 13, color: "#1d6f42", margin: 0 }}
            >
              Visio instantanée : le client entrera directement en
              visioconférence via ce lien (aucun RDV, aucun créneau consommé).
            </p>
          ) : (
            this.hasAppointment() && (
              <FormCheckbox
                className="mb-20"
                text={`RDV déjà pris — envoyer une confirmation (${this.formatAppointmentDate()} à ${this.formatAppointmentHour()})`}
                name="isConfirmation"
                checked={this.state.messageMode === "confirmation"}
                onChange={(e) =>
                  this.setState({
                    messageMode: e.target.checked
                      ? "confirmation"
                      : "invitation",
                  })
                }
              />
            )
          )}
          <FormTextarea
            className="mb-20"
            name={activeField}
            value={activeMessage}
            onChange={this.handleInputChange}
            rows={10}
          />
          <Row>
            <Col xs={12} md={6}>
              <Button
                outline
                className="mb-20"
                text="Annuler"
                onClick={() => this.props.onClose()}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </Col>
            <Col xs={12} md={6}>
              <Button
                className="mb-20"
                text="Confirmer l'envoi"
                disabled={
                  !activeMessage ||
                  this.state.email === "DEFAULT" ||
                  (this.state.email === "Autre" && !this.state.otherEmail)
                }
                onClick={() => this.sendEmail()}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
              </Button>
            </Col>
          </Row>
        </Modal>
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
